import AssetDetail from './AssetDetail.container';

export default AssetDetail;
